import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ItemCodeSelect from "Dashboard/components/ItemCodeSelect";
import NumberInput from "Dashboard/components/NumberInput";
import UnitSelect from "Dashboard/components/UnitSelect";
import { IOption } from "Dashboard/domain/IOption";
import classesStock from "Dashboard/scenes/Stock/popover.module.scss";
import { useAppDispatch } from "hooks/hooks";
import DatePicker from "react-datepicker";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue
} from "react-hook-form";
import { toast } from "react-toastify";
import { FormatDateIso } from "utils/dateUtils";
import classes from "../../../../../../components/Popover/popover.module.scss";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import PartnerSimpleSelect from "../../../../Partners/components/PartnerSimpleSelect";
import { IStockInputCreate } from "../../../domain/IStockInputCreate";
import { stockService } from "../../../services/stock.service";
import { addNewInput } from "../inputSlice";
import DriverSelectCreate from "./DriverSelectCreate";
import RepositorySelect from "./RepositorySelect";
import StockItemSelectCreate from "./StockItemSelectCreate";

interface IProps {
  setIsOpen: Function;
  handleSubmit: UseFormHandleSubmit<IStockInputCreate>;
  setValue: UseFormSetValue<IStockInputCreate>;
  getValues: UseFormGetValues<IStockInputCreate>;
  register: UseFormRegister<IStockInputCreate>;
  control: Control<IStockInputCreate, any>;
  errors: Partial<FieldErrorsImpl<IStockInputCreate>>;
  reset: () => void;
  knownItemCodes: string[];
  setKnownItemCodes: React.Dispatch<React.SetStateAction<string[]>>;
  supplierValue: IOption | undefined;
  setSupplierValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
  driverValue: IOption | undefined;
  setDriverValue: React.Dispatch<React.SetStateAction<IOption | undefined>>;
}

const NewStockInputPopover = (props: IProps) => {
  const dispatch = useAppDispatch();

  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    control,
    errors,
    reset,
    knownItemCodes,
    setKnownItemCodes,
  } = props;

  const onSubmit = async (data: IStockInputCreate) => {
    console.log("create new input", data);
    try {
      const newInput = await stockService.createStockInput("Lager", data);
      dispatch(addNewInput(newInput));
      close();
      toast.success("Input uspesno dodat!");
    } catch (err: any) {
      if (err.response.status === 400) {
        toast.error("Molimo vas unesite odgovarajucu šifru artikla i jedinicu mere!");
      }
    }
  };

  const close = () => {
    props.setIsOpen(false);
    reset();
    props.setSupplierValue(undefined);
    props.setDriverValue(undefined);
  };

  const numberToString = (n: number) => {
    if (n === undefined || n === null) {
      return undefined;
    }
    return n.toString().replace(".", ",");
  }

  return (
    <form
      className={`${classesStock.newStockInputPopover} ${classes.basicPopover}`}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.itemId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>naziv</label>
          <Controller
            name="itemId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <StockItemSelectCreate
                value={getValues("itemId")}
                setValue={setValue}
                setKnownItemCodes={setKnownItemCodes}
                quantityUnit={"quantityUnit"}
                error={errors.itemId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.repositoryId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>magacin</label>
          <Controller
            name="repositoryId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <RepositorySelect
                value={getValues("repositoryId")}
                error={errors.repositoryId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.supplierPartnerId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>dobavljač</label>
          <Controller
            name="supplierPartnerId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <PartnerSimpleSelect
                value={props.supplierValue}
                setValue={props.setSupplierValue}
                error={errors.supplierPartnerId}
                customStyles={styles.customStyleClassic}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.broughtByDriverId ? classes.itemError : ""}`}>
          <label className={classes.mr5}>prevoznik</label>
          <Controller
            name="broughtByDriverId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <DriverSelectCreate
                value={props.driverValue}
                setValue={props.setDriverValue}
                customStyles={styles.customStyleClassic}
                error={errors.broughtByDriverId}
                onChange={onChange}
                preserveInput={true}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. računa</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors.receiptNumber ? classes.itemError : ""}`}
            {...register("receiptNumber", { required: false })}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. otpremnice</label>
          <input type="text" className={`${classes.itemBorder}
            ${errors.billOfLandingId ? classes.itemError : ""}`}
            {...register("billOfLandingId", { required: true })}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>šifra artikla</label>
          <Controller
            name="itemCode"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <ItemCodeSelect
                value={getValues("itemCode")}
                knownItemCodes={knownItemCodes}
                customStyles={styles.customStyleClassic}
                error={errors.itemCode}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>količina</label>
          <Controller
            name="quantityAmount"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <NumberInput
                formatAs="quantity"
                value={numberToString(getValues("quantityAmount"))}
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${errors.quantityAmount ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}
          ${errors.quantityUnit ? classes.itemError : ""}`}>
          <label className={classes.mr5}>jedinica mere</label>
          <Controller
            name="quantityUnit"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <UnitSelect
                value={getValues("quantityUnit")}
                customStyles={styles.customStyleClassic}
                error={errors.quantityUnit}
                onChange={onChange}
              ></UnitSelect>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena po jed. mere</label>
          <Controller
            name="pricePerUnit"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <NumberInput
                formatAs="rsd"
                value={numberToString(getValues("pricePerUnit"))}
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${errors.pricePerUnit ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>cena transporta</label>
          <Controller
            name="deliveryPrice"
            control={control}
            defaultValue={undefined}
            rules={{
              required: false,
            }}
            render={({ field: { onChange } }) => (
              <NumberInput
                formatAs="rsd"
                value={numberToString(getValues("deliveryPrice"))}
                onChange={(value: string, unmaskedValue: string, parsedValue: number) => onChange({ target: { value: unmaskedValue } })}
                className={`${classes.itemBorder} ${errors.deliveryPrice ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>napomena</label>
          <input type="text" className={classes.itemBorder}
            {...register("note")} />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum</label>
          <Controller
            control={control}
            name="date"
            defaultValue={FormatDateIso(new Date())}
            rules={{ required: false }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={`${classes.itemBorder} ${classes.dateItem}
                    ${errors.date ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>xxx</label>
          <div>
            <input type="checkbox" className={classes.itemBorder}
              {...register("xxx")} />
          </div>
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewStockInputPopover;
